import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { UseSnCode } from 'utils/useSnCode';
import { buildPatientExportTable } from './patient-export-columns';

interface ExportProps {
    data: any[];
    filter: any;
    t: any;
    checkNumber: (value: any) => boolean;
    checkNull: (value: any) => any;
    toBuddhistYear: (momentObj: moment.Moment, format: string) => string;
}

const thinBorder = {
    top: { style: 'thin' as const },
    left: { style: 'thin' as const },
    bottom: { style: 'thin' as const },
    right: { style: 'thin' as const }
};

const exportPatientListToExcel = async (props: ExportProps) => {
    const sn = await UseSnCode()

    const { data, filter, t, toBuddhistYear } = props;
    const { headers, rows } = buildPatientExportTable(data, {
        t,
        sn: !!sn,
        formatDate: (value: any) => toBuddhistYear(moment(value), 'DD/MM/YYYY'),
    })
    const dateOfBirthColumn = headers.indexOf('REPORT.TABLE.PATIENT.DATE_OF_BIRTH') + 1

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(t(`REPORT.REPORT_NAME.PATIENT_INFORMATION`));
    const reportNameRow = sheet.addRow([t(`REPORT.REPORT_NAME.PATIENT_INFORMATION`)]);
    reportNameRow.font = { bold: true, size: 16 };
    sheet.mergeCells(1, 1, 1, headers.length);
    reportNameRow.alignment = { horizontal: 'center' };

    const filterInfoRow = sheet.addRow([
        `${t('REPORT.FILTER.BRANCH')}: ${filter.branch || '-'}`,
    ]);
    filterInfoRow.font = { size: 12 };
    sheet.mergeCells(2, 1, 2, headers.length);
    const headerRow = sheet.addRow(headers.map((header) => t(header)));
    headerRow.font = { bold: true, size: 12 };
    headerRow.alignment = { horizontal: 'center' };
    headerRow.eachCell((cell) => { cell.border = thinBorder });

    rows.forEach((rowValues) => {
        const dataRow = sheet.addRow(rowValues);
        dataRow.height = 20;
        if (dateOfBirthColumn > 0) dataRow.getCell(dateOfBirthColumn).numFmt = '@';
        dataRow.eachCell((cell) => { cell.border = thinBorder });
    });

    for (let i = 1; i <= headers.length; i++) {
        sheet.getColumn(i).width = 20;
        sheet.getColumn(i).alignment = { vertical: 'top', horizontal: i === 1 ? 'center' : 'left' };
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${t(`REPORT.REPORT_NAME.PATIENT_INFORMATION`)}.xlsx`);
};

export default exportPatientListToExcel;
